export function getRouteParam(props, key) {
  const computedParams = props && props.computedMatch && props.computedMatch.params && props.computedMatch.params[key];
  const params = props && props.match && props.match.params && props.match.params[key];

  return computedParams || params;
}
